export const GRANTS_PATH = {
  MANAGE_MEMBERS: '/organization/manage',
  JOIN_ORGANIZATION: '/grants/join-organization',
  HOME: '/grants/home',
  REPORTS: '/grants/grantee-reports',
  ORGANIZATION_DETAILS: '/grants/organization-details',
  COMMITTEES: '/grants/Committees',
  WORKGROUPS: '/grants/Workgroups',
  EDIT_COMMITTEE: '/grants/EditCommittee',
  EDIT_WORKGROUP: '/grants/EditWorkgroup',
  ACTION_TEMPLATES: '/admin/action-templates',
  ACTION_TEMPLATE: '/admin/action-template',
  EXECUTIVE_SUMMARIES: '/grants/executive-summaries',
  SERVICE_INVENTORY: '/grants/ServiceInventory',
  EDIT_SERVICE: '/grants/EditService',
  REVIEW_APPLICATION: '/grants/review-application',
  APPLICATION: '/grants/Application',
  ELIGIBILITY_RECHECK: '/grants/eligibility-recheck',
  CALENDAR: '/calendar',
  ACTION_PLAN: '/grants/ActionPlan',
  REVIEWER_PROFILE: '/grants/reviewer-profile',
  APPLY_TO_EXTERNAL_REVIEWER: '/grants/apply-to-external-reviewer',
  ASSIGNED_REVIEWS: '/grants/assigned-reviews',
  EXTERNAL_REVIEW_SURVEY: '/grants/ExternalReviewSurvey',
  ACCEPT_REVIEW: '/grants/AcceptReview',
  PRINT: '/grants/print',
  ORGANIZATIONS: '/grants/Organizations',
  USER_PROFILE: '/grants/user-profile'
} as const
